import React, { useState } from "react";
import Box from "@mui/material/Box";
import Stepper from "@mui/material/Stepper";
import Step from "@mui/material/Step";
import StepButton from "@mui/material/StepButton";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Unstable_Grid2";
import { styled } from "@mui/material/styles";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import CardMedia from "@mui/material/CardMedia";
import CardContent from "@mui/material/CardContent";
import CardActions from "@mui/material/CardActions";
import Collapse from "@mui/material/Collapse";
import Avatar from "@mui/material/Avatar";
import IconButton from "@mui/material/IconButton";
import { red, green } from "@mui/material/colors";
import FavoriteIcon from "@mui/icons-material/Favorite";
import ShareIcon from "@mui/icons-material/Share";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TextField from "@mui/material/TextField";
import jMoment from "moment-jalaali";
import Chip from "@mui/material/Chip";

const ExpandMore = styled((props) => {
  const { expand, ...other } = props;
  return <IconButton {...other} />;
})(({ theme, expand }) => ({
  transform: !expand ? "rotate(0deg)" : "rotate(180deg)",
  marginLeft: "auto",
  transition: theme.transitions.create("transform", {
    duration: theme.transitions.duration.shortest,
  }),
}));

const ProcessCardDoctors = (props) => {
  const [expanded, setExpanded] = useState(false);
  const task = props.task;
  const id = props.id;
  const orderTypeProcesses = props.orderTypeProcesses;

  const handleExpandClick = () => {
    setExpanded(!expanded);
  };
  return (
    <Card>
      <CardHeader
        title={
          <Grid container spacing={1} sx={{ justifyContent: "center" }}>
            {task.processIds
              .map(
                (id) => orderTypeProcesses.find((p) => p.id == id)?.stationName
              )
              .map((op, key) => {
                return (
                  <>
                    <Grid key={key}>
                      <Chip
                        label={op}
                        color={task.isDone ? "success" : "error"}
                      />
                    </Grid>
                  </>
                );
              })}
          </Grid>
        }
      />
      <CardContent sx={{ mt: -3 }}>
        <Box sx={{ width: "100%" }}>
          <Grid container spacing={0}>
            <Grid xs={12}>
              <Stepper nonLinear>
                <Step completed={true}>
                  <StepButton color="inherit">
                    {jMoment(Number(task.startDate)).format("jYY/jMM/jDD")}
                  </StepButton>
                </Step>
                <Step completed={task.isDone}>
                  <StepButton color="inherit">
                    {jMoment(Number(task.finishDate)).format("jYY/jMM/jDD")}
                  </StepButton>{" "}
                </Step>
              </Stepper>
            </Grid>
          </Grid>
        </Box>
      </CardContent>
      <CardActions disableSpacing sx={{ justifyContent: "center" }}>
        <Grid container spacing={0}>
          <Grid xs={12}>
            <ExpandMore
              expand={expanded}
              onClick={handleExpandClick}
              aria-expanded={expanded}
              aria-label="show more"
            >
              <ExpandMoreIcon />
            </ExpandMore>
          </Grid>
        </Grid>
      </CardActions>
      <Collapse in={expanded} timeout="auto" unmountOnExit>
        <CardContent>
          <Box>
            <Grid container spacing={1}>
              <Grid md={6} xs={12}>
                <TextField
                  id="unitCount"
                  label="تعداد واحد"
                  defaultValue={task.unitCount}
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled
                />
              </Grid>
              <Grid md={6} xs={12}>
                <TextField
                  id="jawCount"
                  label="تعداد فک"
                  defaultValue={task.jawCount}
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled
                />
              </Grid>
              <Grid md={6} xs={12}>
                <TextField
                  id="upRight"
                  label="فک بالا راست"
                  defaultValue={task.upRight}
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled
                />
              </Grid>
              <Grid md={6} xs={12}>
                <TextField
                  id="upLeft"
                  label="فک بالا چپ"
                  defaultValue={task.upLeft}
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled
                />
              </Grid>
              <Grid md={6} xs={12}>
                <TextField
                  id="downRight"
                  label="فک پایین راست"
                  defaultValue={task.downRight}
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled
                />
              </Grid>
              <Grid md={6} xs={12}>
                <TextField
                  id="downLeft"
                  label="فک پایین چپ"
                  defaultValue={task.downLeft}
                  variant="outlined"
                  fullWidth
                  size="small"
                  disabled
                />
              </Grid>
              <Grid md={12} xs={12}>
                <TextField
                  id="descriptionٍEnter"
                  label="توضیحات ورود"
                  defaultValue={task.entryDescription}
                  variant="outlined"
                  fullWidth
                  multiline
                  size="small"
                  disabled
                />
              </Grid>
              <Grid md={12} xs={12}>
                <TextField
                  id="descriptionExit"
                  label="توضیحات خروج"
                  defaultValue={task.exitDescription}
                  variant="outlined"
                  fullWidth
                  multiline
                  size="small"
                  disabled
                />
              </Grid>
            </Grid>
          </Box>
        </CardContent>
      </Collapse>
    </Card>
  );
};

export default ProcessCardDoctors;
